export enum EModule {
  site = 'SITE',
  overview = 'OVERVIEW',
  point = 'POINT',
}
